"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isObject = void 0;
const isArray_js_1 = require("./isArray.js");
const isBinary_js_1 = require("./isBinary.js");
const isSet_js_1 = require("./isSet.js");
const isObject = (candidate) => typeof candidate === 'object' &&
    candidate !== null &&
    !(0, isArray_js_1.isArray)(candidate) &&
    !(0, isSet_js_1.isSet)(candidate) &&
    !(0, isBinary_js_1.isBinary)(candidate);
exports.isObject = isObject;
